import * as React from 'react';
import { styled } from '@mui/material/styles';

export const EmptyHeader = styled('div')(({ theme }) => ({
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  backgroundColor: theme.palette.primary.light,
  [theme.breakpoints.up('sm')]: {
    minHeight: '128px'
  }
}));

export const BasicEmptyHeader = styled('div')(({ theme }) => ({
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  backgroundColor: theme.palette.primary.light,
  [theme.breakpoints.up('sm')]: {
    minHeight: '64px'
  }
}));
